import React, { useEffect } from 'react';
import { Query } from 'react-apollo';
import { withRouter } from 'react-router';
import Typography from '@material-ui/core/Typography';
import { withStyles } from '@material-ui/core';
import { compose, get } from '../../utility';
import { withAppUser } from '../../shared/authorization/userConsumer';
import { ROLE_ID } from '../../constants';
import getAllInvitesQuery from '../api/getAllInvites.query.graphql';
import { UnControlledTable } from '../../shared/table';
import styles from './superAdmin.styles';

function isSuperAdmin(user) {
  if (!user) return false;
  const nodes = get(user, 'systemAclsByUserId.nodes', []);
  return nodes.some(acl => Number(acl.roleId) === ROLE_ID.SUPER_ADMIN);
}

const columns = [
  { Header: 'Email', accessor: 'email' },
  { Header: 'First name', accessor: 'firstName' },
  { Header: 'Last name', accessor: 'lastName' },
  { Header: 'Status', id: 'inviteStatus', accessor: (row) => row.inviteStatus || '—' },
  { Header: 'Role', id: 'role', accessor: (row) => get(row, 'roleByRoleId.roleName') || '—' },
  {
    Header: 'Requested by',
    id: 'requestedBy',
    accessor: (row) => {
      const u = row.userByRequestedById;
      return u ? `${u.firstName || ''} ${u.lastName || ''}`.trim() || u.email : '—';
    },
  },
  { Header: 'Created', id: 'createdAt', accessor: (row) => row.createdAt ? new Date(row.createdAt).toLocaleDateString() : '—' },
];

function InvitesListC({ classes, user, history }) {
  useEffect(() => {
    if (user && !isSuperAdmin(user)) history.replace('/admin');
  }, [user, history]);

  if (!user || !isSuperAdmin(user)) return null;

  return (
    <div className={classes.root}>
      <Typography className={classes.title} variant="title">Invites (Super Admin)</Typography>
      <Query query={getAllInvitesQuery} variables={{ first: 500 }}>
        {({ data, loading, error }) => {
          if (error) return <Typography color="error">Error loading invites.</Typography>;
          const nodes = get(data, 'allInvites.nodes', []);
          return (
            loading ? <Typography color="textSecondary">Loading…</Typography>
              : <UnControlledTable data={nodes} columns={columns} />
          );
        }}
      </Query>
    </div>
  );
}

export default compose(
  withStyles(styles),
  withAppUser,
  withRouter
)(InvitesListC);
